export default __webpack_public_path__ + "static/media/Snd_Try4.07ca3bf0.mp3";